import {ModuleWithProviders} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {IpdComponent} from './ipd.component';
import {PatientEmrDashboardModule} from './patient-emr-dashboard/patient-emr-dashboard.module';

const routes: Routes = [
    {
        path: 'ipd', component: IpdComponent,
        children: [
            {path: 'admission', loadChildren: 'app/ipd/admission/admission.module#AdmissionModule'},
            {path: 'patient-emr-dashboard/:patientId', loadChildren: 'app/ipd/patient-emr-dashboard/patient-emr-dashboard.module#PatientEmrDashboardModule'},
            {
                path: 'admission/:user_id/:visit_id',
                loadChildren: 'app/ipd/admission/admission.module#AdmissionModule'
            },
            {path: 'admissiontransfer/:patient_id/:visit_Id/:transfer', loadChildren: 'app/ipd/admission/admission.module#AdmissionModule'},
            {
                path: 'admission/:user_id/:visit_id/:admission_id',
                loadChildren: 'app/ipd/admission/admission.module#AdmissionModule'
            },
            {path: 'admissionlist', loadChildren: 'app/ipd/admission-list/admission-list.module#AdmissionListModule'},
            {path: 'admission-request', loadChildren: 'app/ipd/admission-request/admission-request.module#AdmissionRequestModule'},
            // {path: 'listof-admission-request', loadChildren: 'app/ipd/admission-request/listof-admission-request.module#ListofAdmissionRequestModule'},
            {path: 'addmitedlist', loadChildren: 'app/configuration/trn-admission/trn-admission.module#TrnAdmissionModule'},
            {path: 'ipdadvanced/:admission_id', loadChildren: 'app/ipd/ipd-advanced/ipd-advanced.module#IpdAdvancedModule'},
            {
                path: 'dischargelist',
                loadChildren: 'app/ipd/trn-dischargelist/trn-dischargelist.module#TrnDischargelistModule'
            },
            {
                path: 'ipd-sponcer-combination/:user_id/:visit_id/:sponcertype/:patient_id',
                loadChildren: 'app/ipd/ipd-sponsor-combination/ipd-sponsor-combination.module#IpdSponsorCombinationModule'
            },
            {
                path: 'admission-details/:patient_id',
                loadChildren: 'app/ipd/admission-details/admission-details.module#AdmissionDetailsModule'
            },
            {
                path: 'admission-details/:patient_id/:type',
                loadChildren: 'app/ipd/admission-details/admission-details.module#AdmissionDetailsModule'
            },
            {
                path: 'admission-details/:patient_id/:createduserid/:createdvisitid/:sponcertypeadded/:processtypeself',
                loadChildren: 'app/ipd/admission-details/admission-details.module#AdmissionDetailsModule'
            },
            // {path: 'admission', loadChildren: 'app/ipd/admission/admission.module#AdmissionModule'},
            // {path: 'admissionlist', loadChildren: 'app/ipd/admission-list/admission-list.module#AdmissionListModule'},
            {path: 'bedmanagement', loadChildren: 'app/ipd/bed-management/bed-management.module#BedManagementModule'},
            {path: 'discharge', loadChildren: 'app/ipd/discharge/discharge.module#DischargeModule'},
            {path: 'discharge/:admission_id', loadChildren: 'app/ipd/discharge/discharge.module#DischargeModule'},
            {
                path: 'dischargesummary',
                loadChildren: 'app/ipd/discharge-summary/discharge-summary.module#DischargeSummaryModule'
            },
            {
                path: 'timebasecharges',
                loadChildren: 'app/ipd/time-base-charges/time-base-charges.module#TimeBaseChargesModule'
            },
            {path: 'admission/emergency/:user_id/:visit_id', loadChildren: 'app/ipd/admission/admission.module#AdmissionModule'},
            {
                path: 'admissionreq/:user_id/:AdmissionReq_user_id',
                loadChildren: 'app/ipd/admission/admission.module#AdmissionModule'
            },
            {
                path: 'reschedule-admission-request/:admissionRequestId',
                loadChildren: 'app/ipd/admission-request/new-admission-request/new-admission-request.module#NewAdmissionRequestModule'
            },
            {
                path: 'admission-cancel-list',
                loadChildren: 'app/ipd/trn-admission-cancel-list/trn-admission-cancel-list.module#TrnAdmissionCancelListModule'
            },
            {path: 'admission-request-from-queue/:queuePatientId', loadChildren: 'app/ipd/admission-request/admission-request.module#AdmissionRequestModule'},
            {
                path: 'dischargesummarynew',
                loadChildren: 'app/ipd/discharge-summary-new/discharge-summary-new.module#DischargeSummaryNewModule'
            },
            {
                path: 'dischargesummarynew/:admission_id',
                loadChildren: 'app/ipd/discharge-summary-new/discharge-summary-new.module#DischargeSummaryNewModule'
            },
            {
                path: 'dischargesummaryevisit/:visit_id/:eplId',
                loadChildren: 'app/ipd/discharge-summary-new/discharge-summary-new.module#DischargeSummaryNewModule'
            }
        ]
    }
];
export const routing: ModuleWithProviders = RouterModule.forChild(routes);



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/ipd/ipd.routing.ts